import BaseService from "@/services/BaseService";

export default class CoverageGroupService extends BaseService {
  constructor() {
    super('odoo/coverage-group');
  }

  findAllByParams() {
    return this.http.get(`${this._serviceName}`);
  }

}